import React from 'react';

import styled from 'styled-components';

import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Row } from 'apps/auth/components/common/Layout/Row';
import NewInputWrapper from 'apps/auth/components/form-multi/NewInputWrapper';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import media from 'apps/auth/theme/media';

export const SearchIconWrap = styled.div`
    margin-right: 16px;

    ${media.desktop1920} {
        margin-right: 24px;
    }
`;

const focus = (e) => {
    if (e.currentTarget) {
        const input = e.currentTarget.firstElementChild;
        input.focus();
    } else {
        logInfo('Focus method not support');
    }
};

export const InputSearch = (props) => {
    return (
        <Row indent="32px" onClick={(e) => props.toggle(e, true)}>
            <NewInputWrapper
                name="search"
                setFocus={focus}
                leftInputComponent={
                    <SearchIconWrap>
                        <Icon name="search" color="secondary" />
                    </SearchIconWrap>
                }
            >
                <input type="search" placeholder={props.placeholder} autoFocus={props.autoFocus} />
            </NewInputWrapper>
        </Row>
    );
};
